import { CostBreakdown, IInvoice, IInvoiceLine, IOrder, IOrderItem } from '@jumpstart/core';
import { OrderResponseBody } from '@paypal/paypal-js/types/apis/orders';
import {getFunctions, httpsCallable} from 'firebase/functions';
import { FirebaseHandlers } from '../../core/firebase';

const functions = getFunctions();
const invoiceInfoFn: any = httpsCallable(functions,'messaging-invoice-info');
const orderInfoFn: any = httpsCallable(functions,'messaging-order-info');
const invoiceRecalculateFn: any = httpsCallable(functions,'messaging-invoice-recalculate');
const invoiceApproveFn: any = httpsCallable(functions,'messaging-invoice-approve');
const orderCreateFn: any = httpsCallable(functions,'messaging-order-create');

export interface IInvoiceParams {
  production?: boolean;
  invoice: string;
  uid: string;
  dog?: string;
}


export class ActionsService {

  /**
   * returns invoice id
   */
  public static approveInvoice(data: IInvoiceParams & {lines: (IInvoiceLine & {approved: boolean})[]}): Promise<string> {
    return FirebaseHandlers.run<IInvoiceParams, string>({...data, production: process.env.NODE_ENV !== 'development'}, invoiceApproveFn)
  }

  public static createOrder(data: IInvoiceParams & { paypal?: OrderResponseBody }): Promise<IOrder> {
    return FirebaseHandlers.run<IInvoiceParams & { paypal?: OrderResponseBody }, IOrder>({...data, production: process.env.NODE_ENV !== 'development'}, orderCreateFn)
  }

  public static recalculate(data: IInvoiceParams): Promise<{estimate: CostBreakdown;total: CostBreakdown}> {
    return FirebaseHandlers.run<IInvoiceParams, {estimate: CostBreakdown;total: CostBreakdown}>({...data, production: process.env.NODE_ENV !== 'development'}, invoiceRecalculateFn)
  }

  /**
   * For unauth flows where we send links to users, they can get their data without authenticating
   * @TODO remove in the future, we don't want to expose personal data even if we are scrubbing it out
   */
  public static async invoice(uid: string, dogId: string = 'default', invoiceId: string): Promise<{invoice: IInvoice; lines: IInvoiceLine[]}> {
    return FirebaseHandlers.run<{uid: string; dogId?: string; invoice: string}, {invoice: IInvoice; lines: IInvoiceLine[]}>({uid: uid, dogId: dogId, invoice: invoiceId}, invoiceInfoFn)
  }

  /**
   * For unauth flows where we send links to users, they can get their data without authenticating
   * @TODO remove in the future, we don't want to expose personal data even if we are scrubbing it out
   */
  public static async order(uid: string, dogId: string = 'default', orderId: string): Promise<{order: IOrder; items: IOrderItem[]}> {
    return FirebaseHandlers.run<{uid: string; dogId?: string; orderId: string}, {order: IOrder; items: IOrderItem[]}>({uid: uid, dogId: dogId, orderId: orderId}, orderInfoFn)
  }
}
